/**
 * MobileLauncherScreen — the phone surface for the curated app grid.
 *
 * DELIBERATELY MINIMAL, and it exists in Phase 6 rather than Phase 7 for one
 * reason: without a route here, a launcher deployment's landing redirect
 * (`${prefix}/launcher`) falls through MobileShell's catch-all, which navigates
 * to the landing — i.e. to itself. The phone would bounce instead of opening.
 * A landing page that only works on desktop is not a landing page.
 *
 * It mounts the SAME `LauncherView` the desktop deck window does; its grid is
 * already `auto-fill` so it reflows to a phone without a second implementation
 * of the tiles. What is NOT here, and belongs to Phase 7's mobile pass: an
 * entry in `nav.tsx`'s tab model, and a responsive review of the surrounding
 * chrome. Tapping a tile goes to `${prefix}/app/<id>`, which MobileAppScreen
 * already serves — so launching works on a phone today.
 */
import { useNavigate } from 'react-router-dom'
import { ThemedArea, ErrorBoundary } from '@papan/core-ui/ui'
import { LauncherView } from '@papan/launcher/ui'
import { useTenant } from '../hooks/useTenant'
import { useAuth } from '../hooks/useAuth'

export function MobileLauncherScreen() {
  const navigate = useNavigate()
  const { tenantId, isPersonal, activeOrgEmail, isReady } = useTenant()
  const { user } = useAuth()
  const prefix = isPersonal ? '/~' : `/t/${tenantId}`

  return (
    <ThemedArea area="workspace" className="flex h-full min-h-0 flex-col overflow-hidden">
      <ErrorBoundary>
        <LauncherView
          key={tenantId}
          tenantId={tenantId}
          orgEmail={activeOrgEmail}
          enabled={isReady}
          onOpen={(fileId) => navigate(`${prefix}/app/${fileId}`)}
          userName={user?.name}
        />
      </ErrorBoundary>
    </ThemedArea>
  )
}
